Revolution.Module.extend({
    NAME: "mde.bk-sidebar", // OBLIGATOIRE (reflète l'arborescence répertoire : /mde/sidebar.js)

    initialize: function ($) {

        $('body').on('click', '.js-btn-toggle', this.toggleSidebar);
        $('body').on('click', '*:not(span[class^=icon-]):not(.accordion-title)', this.closeSidebar);
    },

    onWindowLoad: function (e) {

    },

    onWindowScroll: function (e) {

    },
    onWindowResize: function (e) {

    },
    toggleSidebar: function (e) {
        var $btn = $(e.currentTarget);
        var $sidebar = $btn.closest('.js-sidebar');

        if ($btn.data('role') === "open") {
            $btn.addClass('hidden').attr('aria-expanded', "true");
            $sidebar.addClass('opened');
        } else {
            $sidebar.removeClass('opened');
            $('button[data-role="open"]').removeClass('hidden').attr('aria-expanded', "false");
        }
    },

    closeSidebar: function (e) {
        e.stopPropagation();
        if (!$(e.currentTarget).hasClass('js-btn-add') &&
            !$(e.currentTarget).closest('.js-sidebar').length &&
            !$(e.currentTarget).closest('.select2-container--open').length &&
            $('.js-sidebar').hasClass('opened') &&
            !$(e.currentTarget).closest('.mfp-content').length) {
            $('.js-sidebar').find('button[data-role="close"]').click();
        }
    }
});
